var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";
import { DataStore } from "../services/datastore.service";
import { EventBus } from "../services/eventbus.service";
let AppContent = class AppContent extends LitElement {
    constructor() {
        super();
        this.loading = false;
        this._title = undefined;
        this.datastore = DataStore.getInstance();
        this.eventbus = EventBus.getInstance();
    }
    createRenderRoot() {
        return this;
    }
    firstUpdated() {
        this._title = this.location.params.title;
        this.loading = true;
        this.datastore
            .fetchContentPage(this._title)
            .then((response) => {
            this.page = response;
        })
            .catch((error) => {
            const e = JSON.parse(error.body);
            if (e.errorcode === 404) {
                this.datastore.redirect("/404");
            }
            else {
                this.eventbus.dispatchError(error);
            }
        })
            .finally(() => (this.loading = false));
        this.requestUpdate();
    }
    render() {
        return html `
      ${this.loading ? html `
           <div class="columns is-centered">
               <div class="column has-text-centered mt-4">
                   <span class="icon has-text-info fa-2x">
                       <i class="fas fa-spin fa-spinner"></i>
                   </span>
               </div>
           </div>
          ` : html `
            ${this.page ? unsafeHTML(this.page?.text)
            : ""}
          `}
    `;
    }
};
__decorate([
    property()
], AppContent.prototype, "location", void 0);
__decorate([
    state()
], AppContent.prototype, "loading", void 0);
AppContent = __decorate([
    customElement("app-content")
], AppContent);
export { AppContent };
//# sourceMappingURL=anon_content.js.map